<template>
  <mt-popup v-model="moduleState.editStoryText" :modal=false position="right" class="edit-main">
    <app-header v-bind="headerConfig" ref="header"></app-header>
    <main class="edit-wrapper" @click.self="addfocus">
      <textarea placeholder="编辑文本，40字以内效果更佳。" ref="editBox" @click.stop=""
                v-model="$store.state.editMsgText" :style="{height: textHeight + 'px'}"></textarea>
    </main>
    <a href="javascript:;" class="finish-btn" @click.stop="close">确认</a>
    <img v-if="guideConf.isShow" :src="'../../static/image/step_' + guideConf.nowProgress + '.png?v=1'"
         @click.self.stop="addfocus">
  </mt-popup>
</template>

<script>
  import {mapState} from 'vuex';
  import {Toast} from 'mint-ui';
  import store from '../store/store';
  import AppHeader from '../components/header';
  import {ComponentName, Methods} from '../const/common';

  export default {
    name: "edit-story-text",
    components: {
      'app-header': AppHeader
    },
    computed: {
      watchEditMsgText() {
        return this.editMsgText;
      },
      ...mapState(['moduleState', 'guideConf', 'editMsgText'])
    },
    data() {
      return {
        headerConfig: {
          title: '编辑故事',
          isStoryMenu: false,
          backNote: store.state.nextPageHeaderConf.editStoryText.backNote,
          backPage: store.state.nextPageHeaderConf.editStoryText.backPage,
          closeModule: ComponentName.EDIT_STORY_TEXT
        },
        textHeight: 0,
        i: 0
      }
    },
    methods: {
      close() {
        if (this.guideConf.isShow) {
          if (this.editMsgText.length <= 0) {
            return false;
          }
          store.state.guideConf.nowProgress = 5;
        }
        Methods.sendTextMsg('txt');
        Methods.cutComponent('all', false);
        store.state.isShortcutInit = true;
        Methods.cutComponent([store.state.nextPageHeaderConf.editStoryText.backPage], true);
        Methods.checkChapterHash(112);
      },
      addfocus() {
        this.$refs.editBox.focus();
        Methods.checkChapterHash(111);
      },
      setSite() {
        Methods.setRoleSite();
      },
      autoHeight() {
        let elem = this.$refs.editBox;

        this.textHeight = 0;
        elem.scrollTop = 0;
        this.$nextTick(function () {
          this.textHeight = elem.scrollHeight;
        })
      }
    },
    mounted() {
      this.$nextTick(function () {
        this.autoHeight();
      });
    },
    watch: {
      watchEditMsgText() {
        store.state.editMsgText = this.editMsgText.replace(store.state.emoReg, "");
        this.autoHeight();
      }
    }
  }
</script>

<style scoped>
  @import "../style/css/edit_story_text.css";
</style>



// WEBPACK FOOTER //
// src/components/edit_story_text.vue